module.exports = __webpack_public_path__ + "static/img/nav7.4ff45f58.png";